import { Component, input } from '@angular/core';

/**
 * The site's section heading: a primary accent bar, the title, a short supporting line under it,
 * and a hairline divider below the block — always left aligned.
 *
 * The visual treatment lives in the global section-heading pattern in `styles.scss` (keyed off the
 * `.sav-section-heading` class this component puts on its host), so this component and the head
 * classes the older pages use render identically.
 *
 * Anything projected into the component sits on the right of the block — carousel arrows, a
 * "view all" link, tabs:
 *
 * ```html
 * <app-section-heading heading="Best Sellers" subtitle="The steepest markdowns in the store">
 *   <a routerLink="/shop">View all</a>
 * </app-section-heading>
 * ```
 */
@Component({
  selector: 'app-section-heading',
  templateUrl: './section-heading.html',
  styleUrl: './section-heading.scss',
  host: { class: 'sav-section-heading' },
})
export class SectionHeading {
  readonly heading = input('');
  readonly subtitle = input('');
  /** Use 3 when the section sits under another `h2` so the document outline stays correct. */
  readonly level = input<2 | 3>(2);
}
